import { Record } from 'immutable';

import { ConnectorListEntity } from '../components/connector-list/connector-list.entity';

export const ConnectorSliceKey = 'main';

export interface IConnectorOriginalSliceState {
	loading: boolean;
	actionInProgress: boolean;
	list: ConnectorListEntity;
}

export const defaults: IConnectorOriginalSliceState = {
	loading: false,
	actionInProgress: false,
	list: ConnectorListEntity.build([]),
};

export class ConnectorOriginalSliceState extends Record<IConnectorOriginalSliceState>(
	defaults
) {
	public static readonly key = ConnectorSliceKey;

	public setLoading(isLoading: boolean): ConnectorOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setActionInProgress(
		isActionInProgress: boolean
	): ConnectorOriginalSliceState {
		return this.set('actionInProgress', isActionInProgress);
	}

	public setConnectorList(
		connectorList: ConnectorListEntity
	): ConnectorOriginalSliceState {
		return this.set('list', connectorList);
	}
}
